<div class="wrapper">
  <mat-spinner [diameter]="120"></mat-spinner>
  <h2 class="wait">{{ 'common.wait' | translate }}</h2>
</div>
